document.querySelectorAll('.faq').forEach(section => {
  const faqItems = section.querySelectorAll('.faq-item');

  const setOpenAnswerHeights = () => {
    section.querySelectorAll('.faq-item--open .faq-item__answer').forEach(answer => {
      answer.style.height = answer.scrollHeight + 'px';
    });
  };
  setOpenAnswerHeights();
  window.addEventListener('resize', setOpenAnswerHeights);

  faqItems.forEach(item => item.addEventListener('click', event => {
    const answer = item.querySelector('.faq-item__answer');
    if (!answer || event.target.closest('.faq-item__answer a')) return;

    if (item.classList.contains('faq-item--open')) {
      item.classList.remove('faq-item--open');
      answer.style.height = 0;
    } else {
      faqItems.forEach(other => {
        other.classList.remove('faq-item--open');
        const otherAnswer = other.querySelector('.faq-item__answer');
        if (otherAnswer) otherAnswer.style.height = 0;
      });
      answer.style.height = answer.scrollHeight + 'px';
      item.classList.add('faq-item--open');
    }
  }));
});
